import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
/**

 */
/**
 * Context for storing information about the current user
 * @param {object}    value.user            The user object associated with the current user
 * @param {String []} value.gates           The array of gates that the current portal is ungated for
 * @param {string}    value.portal          The auth information of the current portal
 * to create the context:
 * <TimelineAuthContext.Provider value={...}>...</TimelineAuthContext.Provider>
 */
export const TimelineAuthContext = /*#__PURE__*/createContext({
  user: null,
  gates: null,
  portal: null
});
TimelineAuthContext.Provider.propTypes = {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'Requireable<InferProps<{ user: Requireable<o... Remove this comment to see the full error message
  value: PropTypes.shape({
    user: PropTypes.object,
    gates: PropTypes.arrayOf(PropTypes.string),
    portal: PropTypes.object
  })
};

/**
 * To access the user, gates, and portal:
 *
 * const { user, gates, portal } = useTimelineAuthContext();
 */
export const useTimelineAuthContext = () => useContext(TimelineAuthContext);